import Dexie from 'dexie';

export class FikoDexieDatabase extends Dexie {


    constructor(vtIsmi: string, tablolar: string[] = ["Sistem", "Ayarlar"], public tablo: string = "Sistem") {
        // ayarlar = {
        //     vt_ismi: 'FikoYT-Sistem',//your database name here

        //     sablon: {
        //         ayarlar: '',
        //     }
        // };
        // const vtIsmi: string = ayarlar.vt_ismi;
        // const vtVersiyon: number = ayarlar.vt_versiyon || 1;
        // const sablon: any = ayarlar.sablon;

        super(vtIsmi);

        let tablo2store: { [tabloIsmi: string]: string } = {};
        for (let i = 0; i < tablolar.length; i++) {
            const element = tablolar[i];
            tablo2store[element] = "";
        }

        this.version(1).stores(tablo2store);
    }

    // tabloDegistir(tablo: string): FikoDexieDatabase {
    //     this.tablo = tablo;
    //     this.close();
    //     this.version(1).stores({ tablo: '' });
    //     this.open();
    //     return this;
    // };

    ekleTek(object: Object) {
        return this.table(this.tablo).add(object);
    }

    ekleCoklu(objects: Object[]) {
        return this.table(this.tablo).bulkAdd(objects);
    }

    sayisi(table: string) {
        return this.table(this.tablo).count();
    }

    ekleYadaGuncelleTek(object: Object | null, key?: any) {

        if (key) {
            return this.table(this.tablo).put(object, key);
        } else {
            return this.table(this.tablo).put(object);
        }
    }

    ekleYadaGuncelleCoklu(objects: Object[], keys?: any) {
        if (keys) {
            return this.table(this.tablo).bulkPut(objects, keys);
        } else {
            return this.table(this.tablo).bulkPut(objects);
        }
    }

    silTek(primaryKey: any) {
        return this.table(this.tablo).delete(primaryKey);
    }

    silCoklu(primaryKeys: any[]) {
        return this.table(this.tablo).bulkDelete(primaryKeys);
    }

    silTumu() {
        return this.table(this.tablo).clear();
    }

    operateOnEach(callback: (item: any, idbCursor: any) => any) {
        return this.table(this.tablo).each(callback);
    }

    filitrele(filterFunction: (value: any) => boolean) {
        return this.table(this.tablo).filter(filterFunction);
    }

    getByPrimaryKey(primaryKey: any, callback?: (item: any) => any) {
        if (callback) {
            return this.table(this.tablo).get(primaryKey, callback);
        } else {
            return this.table(this.tablo).get(primaryKey);
        }
    }

    getByKeyToValueMap(keyValueMap: Object, callback?: (item: Object) => any) {
        if (callback) {
            return this.table(this.tablo).get(keyValueMap, callback);
        } else {
            return this.table(this.tablo).get(keyValueMap);
        }
    }

    getFirstNItemsOfTable(num: number) {
        return this.table(this.tablo).limit(num);
    }

    sirala(index: string) {
        return this.table(this.tablo).orderBy(index);
    }

    offset(ignoreUpto: number) {
        return this.table(this.tablo).offset(ignoreUpto);
    }

    reverse(table: string) {
        return this.table(this.tablo).reverse();
    }

    toArray(callback?: (objects: Object[]) => any) {
        if (callback) {
            return this.table(this.tablo).toArray(callback);
        } else {
            return this.table(this.tablo).toArray();
        }
    }

    toCollection(table: string) {
        return this.table(this.tablo).toCollection();
    }

    update(key: any, changes: Object) {
        return this.table(this.tablo).update(key, changes);
    }


}